<template>
  <el-popover v-model="visible" :placement="placement" :width="+width" popper-class="filter-popover" trigger="click">
    <slot></slot>
    <div class="btnBox flex_c_c">
      <el-button class="cancel flex_c_c" @click="reset">重 置</el-button>
      <el-button class="ok flex_c_c" @keyup.enter.native="ok" @click="ok">筛 选</el-button>
      <el-button class="export flex_c_c" :loading="loadingExport" @keyup.enter.native="exportData" @click="exportData">导 出</el-button>
      <slot name="customsBtn"></slot>
    </div>
    <div slot="reference" class="reference flex_c_c" :class="{ active: isActive }">
      <svg-icon iconClass="filter" className="icon" />
      <span>{{ isActive ? '已筛选' : '筛选' }}</span>
    </div>
  </el-popover>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'BaseFilter',
  props: {
    placement: {
      type: String,
      default: 'bottom-start'
    },
    isActive: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 400
    }
  },
  data() {
    return {
      visible: false,
      loadingExport: false
    }
  },
  watch: {
    deriveLoading(val) {
      this.loadingExport = val
    }
  },
  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapState({
      deriveLoading: (state) => state.deriveLoading
    })
  },
  methods: {
    ok() {
      this.$emit('sendFilter')
      this.visible = false
    },
    reset() {
      this.$emit('reset')
    },
    async exportData() {
      this.loadingExport = true
      try {
        this.$emit('exportData')
      } finally {
        this.loadingExport = false
      }
    }
  }
}
</script>
<style lang="less" scoped>
.btnBox {
  margin-top: 12px;
  margin-bottom: 12px;
  & div {
    width: 100px;
    height: 40px;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    cursor: pointer;
  }
}

.cancel {
  background: #EEEEEE;
  color: #999999;
  box-sizing: border-box;
  margin-right: 15px;
  width: 80px;

}

.export {
  background: #29a59b;
  color: #FFFFFF;
  width: 80px;

}

.ok {
  background: #142E79;
  color: #FFFFFF;
  margin-right: 15px;
  width: 80px;

}

.reference {
  width: 84px;
  height: 30px;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #EEEEEE;
  font-size: 14px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  box-sizing: border-box;
  cursor: pointer;

  .icon {
    font-size: 20px;
  }
}

.active {
  border-color: #2395F3;
  color: #2395F3;
}
</style>
